import "./unicorn.scss";
import { apiGet, apiPost, getHostApi, parseQuery, hasPermission, getHostUrl } from "../../store/apiWrapper";
import { bindActionCreators } from "redux";
import { Circles } from "../common/loadingComponent";
import { Collapse } from "reactstrap";
import { connect } from "react-redux";
import { domainActions } from "../../store/domainStore";
import { FileUpload } from "../common/fileUpload";
import { filterMulti, loadMulti, findParents, findChildren, loadMultiCities } from "../../store/multiSelectFunction";
import { Formik, Form } from 'formik';
import { cloneDeep, isEqual, pick } from 'lodash';
import { layoutActions } from "../../store/layoutStore";
import { marketingListActions, emptySectionsModel, emptyFileModel, unicornCountry, unicornAttribute, unicornAttributes, unicornFinValues, unicornFinValuesIfrs, unicornFinValuesIfrsOriginal, expandType, unicornFinStatementOrganizationValues } from "../../store/marketingListStore";
import { isGuid, isNullOrUndefined, isValidLanguage } from '../../store/storeFunctions';
import { popupActions } from "../../store/popupStore";
import { withLocalize, Translate } from "react-localize-redux";
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom'
import { writeErr } from '../common/logger';
import * as Yup from '../common/Yup';
import ActivityScope from '../searchSections/activityScope';
import AdditionalInfo from "../searchSections/additionalInfo";
import Address from "./sections/address";
import ByRelation from "./sections/byRelation";
import classnames from 'classnames'
import ColumnWrap from "./columnWrap";
import CrossIcon from "../../img/icons/Cross";
import ExtendedSearchComponent from "../searchSections/extendedSearchComponent";
import Vehicles from "../searchSections/vehicles";
import FinancialStatements from "../searchSections/financialStatements";
import ForeignTrade from "../searchSections/foreignTrade";
import LegalForm from "./sections/legalForm";
import RegisteredCapital from "./sections/registeredCapital";
import Message from "../common/message";
import moment from "moment";
import NavigationRow from "../layoutItems/navigationRow";
import Navigator from "./navigator";
import React, { Component } from "react";
import SubjecRating from "../searchSections/subjectRating";
import SubjectLiabilities from "../searchSections/subjectLiabilities";
import SubjectStatus from '../searchSections/subjectStatus';
import SubjectWarnings from "../searchSections/subjectWarnings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BbRadioWrapper from "../styling/BbRadioWrapper";
import { BbSelectNoFormik } from '../styling/bbInput';
import SelectOption from '../searchSections/selectOption';

const SEARCH_TYPE_ADD = "ADD_VALUES";
const SEARCH_TYPE_REMOVE = "REMOVE_VALUES";

class Parameters extends Component {
    state = {
        loading: true,
        result: null,
        fileChanged: false,
        isSubmitting: false,
        hasData: false,
        cannotEdit: false,
        isEditing: false,
        showFileBox: false,
        showPortfolio: false,
        hasMlAccount: null,
        error: null,
        isTemplate: false,
        searchPortfolio: false,
        portfolioLoaded: false,
        portfolios: null,
        portfolioId: null,
        portfolioSearchType: SEARCH_TYPE_ADD,
        excelSearchType: SEARCH_TYPE_ADD
    }

    _sectionMap = {
        "legalForm": (label, searchTip, errors) => <ColumnWrap key={'legalForm'} column="is-12" style={{ padding: '.25em' }}>
            <LegalForm label={label} isOpen={true} />
        </ColumnWrap>,
        "relationship": (label, searchTip, errors) => <ColumnWrap key={'relationship'} column="is-12" style={{ padding: '.25em' }}>
            <ByRelation label={label} isOpen={true} searchTip={searchTip} errors={errors} />
        </ColumnWrap>,
        "addr": (label, searchTip, errors) =>
            <ColumnWrap key={'addr'} column="is-12" style={{ padding: '.25em' }}>
                <Address label={label} isOpen={true} searchTip={searchTip} errors={errors} />
            </ColumnWrap>,
        "premises": (label, searchTip, errors) =>
            <ColumnWrap key={'premises'} column="is-12" style={{ padding: '.25em' }}>
                <ExtendedSearchComponent type="params" field="premises" label={label} isOpen={true} searchTip={searchTip} errors={errors}></ExtendedSearchComponent>
            </ColumnWrap>,
        "contracts": (label, searchTip, errors) => <ColumnWrap key={'contracts'} column="is-12" style={{ padding: '.25em' }}>
            <ExtendedSearchComponent type="params" field="contracts" label={label} isOpen={true} searchTip={searchTip} errors={errors}></ExtendedSearchComponent>
        </ColumnWrap>,
        "procurements": (label, searchTip, errors) => <ColumnWrap key={'procurements'} column="is-12" style={{ padding: '.25em' }}>
            <ExtendedSearchComponent type="params" field="procurements" label={label} isOpen={true} searchTip={searchTip} errors={errors}></ExtendedSearchComponent>
        </ColumnWrap>,
        "rating": (label, searchTip, errors) => <ColumnWrap key={'rating'} column="is-12" style={{ padding: '.25em' }}>
            <SubjecRating label={label} open={true} />
        </ColumnWrap>,
        "foreignTrade": (label, searchTip, errors) => <ColumnWrap key={'foreignTrade'} column="is-12" style={{ padding: '.25em' }}>
            <ForeignTrade label={label} isOpen={true} />
        </ColumnWrap>,
        "status": (label, searchTip, errors) => <ColumnWrap key={'status'} column="is-12" style={{ padding: '.25em' }}>
            <SubjectStatus label={label} isOpen={true} searchTip={searchTip} errors={errors} />
        </ColumnWrap>,
        "activity": (label, searchTip, errors) => <ColumnWrap key={'activity'} column="is-12" style={{ padding: '.25em' }}>
            <ActivityScope label={label} isOpen={true} searchTip={searchTip} errors={errors} />
        </ColumnWrap>,
        "grants": (label, searchTip, errors) => <ColumnWrap key={'grants'} column="is-12" style={{ padding: '.25em' }}>
            <ExtendedSearchComponent type="params" field="grants" label={label} isOpen={true} searchTip={searchTip} errors={errors}></ExtendedSearchComponent>
        </ColumnWrap>,
        "sources": (label, searchTip, errors) => <React.Fragment key={'sources'}>
            <ColumnWrap column="is-12" style={{ padding: '.25em' }}><SubjectLiabilities type="positive" isOpen={true} /></ColumnWrap>
            <ColumnWrap column="is-12" style={{ padding: '.25em' }}><SubjectLiabilities type="negative" isOpen={true} /></ColumnWrap>
        </React.Fragment>,
        "additional": (label, searchTip, errors) => <React.Fragment key={'additional'}>
            <ColumnWrap column="is-12" style={{ padding: '.25em' }}><AdditionalInfo type='positive' isOpen={true} /></ColumnWrap>
            <ColumnWrap column="is-12" style={{ padding: '.25em' }}><AdditionalInfo type='negative' isOpen={true} /></ColumnWrap >
        </React.Fragment>,
        "warnings": (label, searchTip, errors) => <React.Fragment key={'warnings'}>
            <ColumnWrap column="is-12" style={{ padding: '.25em' }}><SubjectWarnings warningType="positive" isOpen={true} /></ColumnWrap>
            <ColumnWrap column="is-12" style={{ padding: '.25em' }}><SubjectWarnings warningType="negative" isOpen={true} /></ColumnWrap>
        </React.Fragment>,
        "financial": (label, searchTip, errors) => <ColumnWrap key={'financial'} column="is-12" style={{ padding: '.25em' }}>
            <FinancialStatements label={label} isOpen={true} errors={errors} />
        </ColumnWrap>,
        "vehicles": (label, searchTip, errors) =>
            <ColumnWrap key={'vehicles'} column="is-12" style={{ padding: '.25em' }}>
                <Vehicles field="vehicles" label={label} isOpen={true} searchTip={searchTip} errors={errors}></Vehicles>
            </ColumnWrap>,
        "registeredCapital": (label, searchTip, errors) =>
            <ColumnWrap key={'registeredCapital'} column="is-12" style={{ padding: '.25em' }}>
                <RegisteredCapital field="registeredCapital" label={label} isOpen={true} searchTip={searchTip} errors={errors}></RegisteredCapital>
            </ColumnWrap>
    };

    render() {
        if ((unicornCountry() === 'cz' && hasPermission(null, 'AccessCzechData'))
            || (unicornCountry() === 'sk' && hasPermission(null, 'AccessSlovakData')))
            return this.state.loading ? <Circles /> : this.renderPage();
        else
            return <Redirect to={`/notAuthorized?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
    }

    renderPage() {
        return (
            <>
                <div className="content-root">
                    {this.state.hasMlAccount ?
                        <>
                            <Navigator isEditing={this.state.isEditing} />
                            <div>
                                <div className="columns is-multiline">
                                    {this.state.result !== null && !this.state.result.isSuccess && this.renderError()}
                                    <div className="column is-6 is-centered" >
                                        <Collapse tag="div" className="column is-12" isOpen={this.state.showFileBox} style={{ padding: "0 1.25em" }}>
                                            <div className="file-upload-box">
                                                <div className="column is-12">
                                                    <div className="column is-6" style={{ float: 'left', padding: "0" }}>
                                                        <div className="btn-wrap">
                                                            <div className="po-button" style={{ fontWeight: '600' }}><Translate id={"MarketingList.ExcelBoxName"} /></div>
                                                            <div className="search-progress-short"></div>
                                                        </div>
                                                    </div>
                                                    <div className="column is-6" style={{ float: 'right', padding: "0" }}>
                                                        <div className="remove-marketingBox">
                                                            <CrossIcon onClick={() => { this.resetCallback(); this.setState({ showFileBox: !this.state.showFileBox }) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="control" style={{ marginTop: '3.5em' }}>
                                                    <FileUpload
                                                        initialFile={this.props.ml.sections.xlsFileContent}
                                                        callback={(file) => { this.props.upload(file); this.setState({ result: null, fileChanged: true }); }}
                                                        resetCallback={() => this.resetCallback()}
                                                    >
                                                        <div className="excel-icons">
                                                            <a className="link-functional" style={{ textAlign: "center" }} href={this.getBulkTemplateUrl(this.props.activeLanguage.code)} download><Translate id="Search.Common.BulkTemplate" /></a>
                                                        </div>
                                                    </FileUpload>
                                                </div>
                                                <div style={{ marginTop: '2em' }}>
                                                    <BbRadioWrapper name="excelFilter" id="excel_filter_remove"
                                                        checked={this.state.excelSearchType === SEARCH_TYPE_REMOVE} callback={() => this.setState({ excelSearchType: SEARCH_TYPE_REMOVE })}
                                                        label={
                                                            this.props.translate('MarketingList.RemoveSubjectsFromExcel')
                                                        }
                                                    />
                                                    <BbRadioWrapper name="excelFilter" id="excel_filter_add"
                                                        checked={this.state.excelSearchType === SEARCH_TYPE_ADD} callback={() => this.setState({ excelSearchType: SEARCH_TYPE_ADD })}
                                                        label={
                                                            this.props.translate('MarketingList.AddSubjectsFromExcel')
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </Collapse>
                                        <div className="column is-12 is-centered" style={{ padding: (this.state.showFileBox || this.hasCheckedSection()) ? "2em 0" : "4em 0" }}>
                                            <div className="column is-offset-6 is-4">
                                                {!this.state.showFileBox && <button onClick={() => this.setState({ showFileBox: true })} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                                    <Translate id={"MarketingList.Criteria.AddList"} />
                                                </button>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="column is-6 is-centered">
                                        <Collapse tag="div" className="column is-12" isOpen={this.state.showPortfolio} style={{ padding: "0 1.25em" }}>
                                            <div className="file-upload-box">
                                                <div className="column is-12">
                                                    <div className="column is-6" style={{ float: 'left', padding: "0" }}>
                                                        <div className="btn-wrap">
                                                            <div className="po-button" style={{ fontWeight: '600' }}><Translate id={"MarketingList.PortfolioBoxName"} /></div>
                                                            <div className="search-progress-short"></div>
                                                        </div>
                                                    </div>
                                                    <div className="column is-6" style={{ float: 'right', padding: "0" }}>
                                                        <div className="remove-marketingBox">
                                                            <CrossIcon onClick={() => { this.resetPortfolio(); this.setState({ showPortfolio: !this.state.showPortfolio }) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="control" style={{ marginTop: '3.5em' }}>
                                                    <BbSelectNoFormik options={this.getConditionLabels()}
                                                        formatOptionLabel={SelectOption}
                                                        onChange={(e) => { this.setState({ portfolioId: e.value }) }}
                                                        value={!isNullOrUndefined(this.getConditionLabels()) && this.getConditionLabels().filter(option => option.value === this.state.portfolioId)}
                                                        selectPlaceholder={
                                                            this.props.translate('MarketingList.PortfolioName')
                                                        } />
                                                </div>
                                                <div style={{ marginTop: '2em' }}>
                                                    <BbRadioWrapper name="portfolioFilter" id="portfolio_filter_remove"
                                                        checked={this.state.portfolioSearchType === SEARCH_TYPE_REMOVE} callback={() => this.setState({ portfolioSearchType: SEARCH_TYPE_REMOVE })}
                                                        label={
                                                            this.props.translate('MarketingList.RemoveSubjectsFromPortfolio')
                                                        }
                                                    />
                                                    <BbRadioWrapper name="portfolioFilter" id="portfolio_filter_add"
                                                        checked={this.state.portfolioSearchType === SEARCH_TYPE_ADD} callback={() => this.setState({ portfolioSearchType: SEARCH_TYPE_ADD })}
                                                        label={
                                                            this.props.translate('MarketingList.AddSubjectsFromPortfolio')
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </Collapse>
                                        <div className="column is-12 is-centered" style={{ padding: (this.state.showPortfolio || this.hasCheckedSection()) ? "2em 0" : "4em 0" }}>
                                            <div className="column is-4 is-offset-1">
                                                {!this.state.showPortfolio && <button onClick={() => this.setState({ showPortfolio: true })} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                                    {<Translate id={"MarketingList.AddPortfolio"} />}
                                                </button>}
                                            </div>
                                        </div>
                                    </div>
                                    {this.renderForm()}
                                </div>
                            </div>
                        </>
                        :
                        <div className="columns">
                            <div className="column">
                                <div className="card card-special">
                                    <Message type="error" message={this.props.translate("UnhappyUser.NoValidAccount")} />
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <NavigationRow justify='flex-end'>
                    {this.state.hasMlAccount && <>
                        {!this.state.isSubmitting && this.state.isTemplate && <button onClick={() => { document.querySelector("#fake-submit-params").setAttribute("data-redirect", "save"); document.querySelector("#fake-submit-params").click() }} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} disabled={!this.canContinue()}>
                            <Translate id="Common.Button.Save"></Translate>
                        </button>}
                        {this.state.isSubmitting && <button className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><FontAwesomeIcon icon='cog' spin={true} /></button>}
                        {!this.state.isSubmitting && <button onClick={() => { document.querySelector("#fake-submit-params").setAttribute("data-redirect", "continue"); document.querySelector("#fake-submit-params").click() }} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} disabled={!this.canContinue()}>
                            <Translate id="Marketing.Navigation.ContinueToConfig"></Translate>
                        </button>}
                    </>}
                </NavigationRow>
            </>
        )
    }

    resetPortfolio = () => {
        this.setState({ portfolioId: null });
    }

    getPortfoliosForMarketingList() {
        apiPost(`${getHostApi()}/api/portfolio/portfoliosForMarketingList/` + unicornCountry(), null, null,
            (s) => {
                if (s.data.isSuccess) {
                    this.setState({ portfolioLoaded: true, portfolios: s.data.items })
                }
            },
            (r) => writeErr(r)
        );
    }

    getConditionLabels = () => {
        return this.state.portfolios;
    }

    createValidationSchema = (sections) => {
        // const pinBdTest = /(^$)|(^\s*(\d\d)(\d\d)(\d\d)[\/]*(\d\d\d)(\d?)\s*$)|(^([0-9]|[0-2][0-9]|(3)[0-1])(\.|\/|-)([0-9]|((0)[0-9])|((1)[0-2]))(\.|\/|-)\d{4}$)/i;
        const pinBdTest = /(^$)|(^\s*(\d\d)(\d\d)(\d\d)[\/]*(\d\d\d)(\d?)\s*$)/i;

        const wrongZip = this.props.translate('MarketingList.Error.Zip');
        const wrongDateRange = this.props.translate('MarketingList.Error.DateRange');
        const wrongNumber = this.props.translate('MarketingList.Error.Number');
        const wrongPositiveOrZeroNumber = this.props.translate('MarketingList.Error.PositiveOrZeroNumber');
        const wrongPositiveOrZeroNumber999 = this.props.translate('MarketingList.Error.PositiveOrZeroNumberMax');
        const maxCities = this.props.translate('MarketingList.Error.Addr.Cities');
        const number999 = 999999999999;
        const wrongDobOrPin = this.props.translate('MarketingList.Error.DobOrPin');

        const schema = {
            'addr': Yup.object().shape({
                'zip': Yup.string().test('zip', wrongZip, function (item) {
                    let section = sections["addr"];
                    let result = isNullOrUndefined(item) || !section.checked || (item.replace(/\s/g, '').length === 0) || (item.replace(/\s/g, '').length === 5);
                    return result;
                }),
                'cities.all.length': Yup.number().max(100, maxCities).transform(emptyStringToNull).nullable()
            }),
            'status': Yup.object().shape({
                'registrationFrom': Yup.string().test('regFrom', wrongDateRange, (item) => dateInRange(item, sections["status"])),
                'registrationTo': Yup.string().test('regTo', wrongDateRange, (item) => dateInRange(item, sections["status"]))
            }),
            'activity': Yup.object().shape({
                'minEmployees': Yup.number().min(0, wrongPositiveOrZeroNumber).transform(emptyStringToNull).nullable(),
                'maxEmployees': Yup.number().min(0, wrongPositiveOrZeroNumber).transform(emptyStringToNull).nullable()
            }),
            'financial': Yup.object().shape({
                'values': Yup.object().shape({
                    'values': Yup.array().of(
                        Yup.object({
                            'from': Yup.number().transform(value => (isNaN(value) ? undefined : value)),
                            'to': Yup.number().transform(value => (isNaN(value) ? undefined : value))
                        })
                    )
                }),
                'ratios': Yup.object().shape({
                    'values': Yup.array().of(
                        Yup.object({
                            'from': Yup.number().transform(value => (isNaN(value) ? undefined : value)),
                            'to': Yup.number().transform(value => (isNaN(value) ? undefined : value))
                        })
                    )
                })
            }),
            'procurements': Yup.object().shape({
                'from': Yup.string().test('regFrom', wrongDateRange, (v) => dateInRange(v, sections["procurements"])),
                'to': Yup.string().test('regTo', wrongDateRange, (v) => dateInRange(v, sections["procurements"])),
                'countFrom': Yup.number().min(0, wrongPositiveOrZeroNumber).transform(emptyStringToNull).nullable(),
                'countTo': Yup.number().min(0, wrongPositiveOrZeroNumber).transform(emptyStringToNull).nullable(),
                'sumFrom': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable(),
                'sumTo': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable()
            }),
            'grants': Yup.object().shape({
                'from': Yup.string().test('regFrom', wrongDateRange, (v) => dateInRange(v, sections["grants"])),
                'to': Yup.string().test('regTo', wrongDateRange, (v) => dateInRange(v, sections["grants"])),
                'countFrom': Yup.number().min(0, wrongPositiveOrZeroNumber).transform(emptyStringToNull).nullable(),
                'countTo': Yup.number().min(0, wrongPositiveOrZeroNumber).transform(emptyStringToNull).nullable(),
                'sumFrom': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable(),
                'sumTo': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable()
            }),
            'contracts': Yup.object().shape({
                'from': Yup.string().test('regFrom', wrongDateRange, (v) => dateInRange(v, sections["contracts"])),
                'to': Yup.string().test('regTo', wrongDateRange, (v) => dateInRange(v, sections["contracts"])),
                'countFrom': Yup.number().min(0, wrongPositiveOrZeroNumber).transform(emptyStringToNull).nullable(),
                'countTo': Yup.number().min(0, wrongPositiveOrZeroNumber).transform(emptyStringToNull).nullable(),
                'sumFrom': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable(),
                'sumTo': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable()
            }),
            'relationship': Yup.object().shape({
                'dob': Yup.string().test('dob', wrongDobOrPin, (v) => (pinBdTest.test(v) && (v % 11 === 0)) || dateInRange(v, sections["relationship"], "DD.MM.YYYY"))
            }),
            'registeredCapital': Yup.object().shape({
                'countFrom': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable(),
                'countTo': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable()
            }),
        }

        let sectionToValidate = ['addr', 'status', 'activity', 'financial', 'procurements', 'grants', 'contracts', 'relationship', 'registeredCapital']
        let validatedSectionsArr = [];

        sectionToValidate.forEach(s => {
            if (sections[s].checked)
                validatedSectionsArr.push(s);
        });

        return Yup.object().shape(pick(schema, validatedSectionsArr));
    }

    renderForm() {
        return (
            <div className="form-holder" data-visible={this.hasCheckedSection() ? "true" : "false"}>
                <Formik
                    enableReinitialize={true}
                    validationSchema={this.createValidationSchema(this.props.ml.sections)}
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.props.ml.sections}
                    ref={(el) => this.formRef = el}
                    onSubmit={(values) => {
                        this.submitSearch(values);
                    }}>
                    {({ values, setFieldValue, errors }) => (
                        <Form noValidate style={{ width: "100%" }} >
                            {Object.keys(this.props.ml.sections).filter(x => x !== "xlsFileContent")
                                .map(x => { return { id: x, order: this.props.ml.sections[x].order } })
                                .filter(x => this.isSectionChecked(x.id) && this._sectionMap[x.id] !== undefined && this.hasSectionPermission(x.id))
                                .sort((a, b) => a.order - b.order)
                                .map(s => this._sectionMap[s.id](this.props.ml.sections[s.id].label, this.props.ml.sections[s.id].searchTip, errors))}
                            <button type="submit" id="fake-submit-params" style={{ visibility: "hidden" }} ></button>
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }

    renderError() {
        if (isNullOrUndefined(this.state.result)) {
            return null;
        }
        return (
            <div className="column is-12 is-centered">
                <Message type="error" message="">
                    {!isNullOrUndefined(this.state.result.errorFile) &&
                        <div>
                            <span>{this.props.translate("Search.Common.Bulk.ErrorFile")}</span>
                            <a href={this.getBulkTempFileUrl(this.state.result.errorFile)} target="_blank" ><Translate id='Search.Common.Bulk.ErrorFileLink' /></a>
                            {!isNullOrUndefined(this.state.result.exception) && this.exception(this.state.result.exception)}
                        </div>
                    }
                    {isNullOrUndefined(this.state.result.errorFile) &&
                        <div>
                            <span><Translate id={this.state.result.error.message || "UnhappyUser.InternalServerError"} options={{ renderInnerHtml: true }} /> </span>
                        </div>
                    }
                </Message>
            </div>
        )
    }

    canContinue = () => {
        //check all flags except excel file
        return this.hasCheckedSection() || !this.hasDefaultFileContent() || !isNullOrUndefined(this.state.portfolioId);
    }

    resetCallback = () => {
        this.props.upload(Object.assign({}, { ...emptyFileModel, reset: true }));
        this.setState({ result: null })
    }

    componentDidMount = () => {
        if (this.state.hasMlAccount === null)
            this.checkMlAccount();
        (!this.props.domain.marketingDomainsLoaded || this.props.domain.marketingDomainsCountry !== unicornCountry()) && this.loadDomains();
        (!this.state.portfolioLoaded && this.getPortfoliosForMarketingList());
        this.props.resetSections();
        this.isEditing();
        if (!this.hasCheckedSection()) {
            this.props.checkSection('legalForm', true);
            this.props.checkSection('addr', true);
            this.props.checkSection('status', true);
            this.props.checkSection('activity', true);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.ml.search !== prevProps.ml.search) {
            this.props.resetSections();
        }

        if (this.props.location.search !== prevProps.location.search || this.props.location.pathname !== prevProps.location.pathname) {
            this.props.resetSections();

            if (this.state.hasMlAccount)
                this.formRef.resetForm();
        }

        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.loadDomains(); //country change
            this.getPortfoliosForMarketingList();
        }

        if ((this.props.domain.marketingDomainsLoaded && this.props.domain.financialDomainsLoaded && this.state.portfolioLoaded && !this.state.loading && !this.state.hasData && this.getRequestId() !== null)) {
            this.loadRequest();
        }
    }

    //load all domain values, if not loaded in time, multiselect cant parse values
    loadDomains = async () => {
        this.props.setMarketingDomainsCountry(unicornCountry())

        this.props.ensureDomainData('nace', { marketAttributes: unicornAttributes() });
        this.props.ensureDomainData('size-categories', { marketAttribute: unicornAttribute() });
        this.props.ensureDomainData('institutional-sectors');
        this.props.ensureDomainData('ownership-types');
        this.props.ensureDomainData('turnover-ranges', { marketAttribute: unicornAttribute() });
        this.props.ensureDomainData('turnover-years', { marketAttribute: unicornAttribute() });
        this.props.ensureDomainData('countries-tree');
        this.props.ensureDomainData('additional-info', { marketAttributes: unicornAttributes() });
        this.props.ensureDomainData('warning-types', { marketAttributes: unicornAttributes() });
        this.props.ensureDomainData('legal-form-types', { addNaturalPerson: false, marketAttributes: unicornAttributes() });
        this.props.ensureDomainData('fin-statement-values', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinValues() });
        if (unicornCountry() === 'sk') {
            this.props.ensureDomainData('fin-statement-values-ifrs', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinValuesIfrs() });
            this.props.ensureDomainData('fin-statement-values-ifrs-original', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinValuesIfrsOriginal() });
            this.props.ensureDomainData('fin-statement-values-ifrs-original', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinValuesIfrsOriginal() });
            this.props.ensureDomainData('fin-statement-values-organizations-values-sasp', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
            this.props.ensureDomainData('fin-statement-values-organizations-values-v', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
            this.props.ensureDomainData('fin-statement-values-organizations-values-vh', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
            this.props.ensureDomainData('fin-statement-values-organizations-values-vp', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
            this.props.ensureDomainData('fin-statement-values-organizations-values-all', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
            this.props.ensureDomainData('fin-statement-values-organizations-types', { marketAttribute: unicornAttribute() });
        }
        this.props.ensureDomainData('fin-statement-ratios', { marketAttributes: unicornAttributes() });
        this.props.ensureDomainData('regions', { marketAttribute: unicornAttribute() });
        this.props.ensureDomainData('districts', { marketAttribute: unicornAttribute() });
        this.props.ensureDomainData('cities', { marketAttribute: unicornAttribute() });
        this.props.ensureDomainData('sources', { marketAttributes: unicornAttributes() });
    }

    loadRequest = () => {
        let id = this.getRequestId()
        if (id === null) {
            //initialize all sections unchecked, no excel file
            this.props.setSections(emptySectionsModel());
            return null;
        }
        //load request and set response as value
        this.setState({ loading: true }, () => {
            apiGet(`${getHostApi()}/api/marketing-list/requests/${id}`, null,
                (r) => {
                    if (!r.data.canEditSearch) {
                        this.setState({ cannotEdit: true });
                    } else {
                        let parsedData = JSON.parse(r.data.input);
                        let x = this.transformToInitialValues(parsedData);
                        this.props.setSections(x);
                        this.setState({
                            showFileBox: (parsedData.xlsFileContent && parsedData.xlsFileContent.fileName !== "") || this.getExpandType() === expandType.excel || this.getExpandType() === expandType.both,
                            excelSearchType: parsedData.excelSearchType && parsedData.excelSearchType !== "" ? parsedData.excelSearchType : SEARCH_TYPE_ADD,
                            showPortfolio: (parsedData.portfolioId && parsedData.portfolioId !== "") || this.getExpandType() === expandType.portfolio || this.getExpandType() === expandType.both,
                            portfolioId: parsedData.portfolioId && parsedData.portfolioId !== "" ? parsedData.portfolioId : null,
                            portfolioSearchType: parsedData.portfolioSearchType && parsedData.portfolioSearchType !== "" ? parsedData.portfolioSearchType : SEARCH_TYPE_ADD,
                            isTemplate: r.data.state === 'Template'
                        })
                    }
                },
                (r) => writeErr(r),
                () => this.setState({ loading: false, hasData: true })
            );
        });
    }

    transformToInitialValues(dv) {
        const result = {};
        let sec = cloneDeep(emptySectionsModel());
        let v = Object.assign({}, dv);

        //xls
        result.xlsFileContent = { ...sec.xlsFileContent, ...dv.xlsFileContent };

        //pravna forma
        result.legalForm = { ...sec.legalForm, ...v.legalForm, ...this.loadMultiLegalForm(v.legalForm, this.props.domain['legal-form-types'], 4, 4) };
        result.legalForm.order = sec.legalForm.order;

        //subjekt podla vazby na zadanu osobu
        result.relationship = sec.relationship || {};
        if (!isNullOrUndefined(v.relationship))
            result.relationship = { ...sec.relationship, ...v.relationship, order: sec.relationship.order };

        //adresa
        result.addr = sec.addr || {};
        if (!isNullOrUndefined(v.addr))
            result.addr = {
                ...sec.addr, ...v.addr, street: v.addr.street.replace(/^\"/, '').replace(/\*\"$/, ''), order: sec.addr.order,
                regions: this.loadMultiCustom(v.addr.regions, v.addr.regions, this.props.domain["regions"], 6, 6),
                districts: this.loadMultiCustom(v.addr.districts, v.addr.districts, this.props.domain["districts"], 8, 8),
                cities: this.loadMultiCity(v.addr.cities, v.addr.cities, this.props.domain["cities"]),
            };

        //prevadzkarne
        if (!isNullOrUndefined(v.premises)) {
            result.premises = {
                ...sec.premises, ...v.premises,
                regions: this.loadMultiCustom(v.premises.regions, v.premises.regions, this.props.domain["regions"], 6, 6),
                districts: this.loadMultiCustom(v.premises.districts, v.premises.districts, this.props.domain["districts"], 8, 8),
                cities: this.loadMultiCity(v.premises.cities, v.premises.cities, this.props.domain["cities"]),
                hasItems: this.loadTriStateDropdown((v.premises || sec.premises).hasItems)
            };
        }

        //zverejnene zmluvy
        result.contracts = this.loadExtended(sec.contracts, v.contracts);

        //verejne obstaravania
        result.procurements = this.loadExtended(sec.procurements, v.procurements);

        //hodnotenie subjektu 
        result.rating = { ...sec.rating, ...v.rating, order: sec.rating.order };

        //zahranicny obchod
        result.foreignTrade = sec.foreignTrade || {};
        result.foreignTrade.import = this.loadMultiCustom(result.foreignTrade.import, v.foreignTrade.import, this.props.domain['countries-tree'], 6);
        result.foreignTrade.export = this.loadMultiCustom(result.foreignTrade.export, v.foreignTrade.export, this.props.domain['countries-tree'], 6);
        result.foreignTrade.checked = v.foreignTrade.checked;

        //statisticke udaje
        result.activity = sec.activity || {};
        result.activity.nace = this.loadMultiCustom(result.activity.nace, v.activity.nace, this.props.domain["nace"]);
        result.activity.naceSource = v.activity.naceSource || sec.activity.naceSource;
        result.activity.onlyMainNace = v.activity.onlyMainNace;
        result.activity.institutionalSectors = this.loadMultiCustom(result.activity.institutionalSectors, v.activity.institutionalSectors, this.props.domain["institutional-sectors"]);
        result.activity.ownerships = this.loadMultiCustom(result.activity.ownerships, v.activity.ownerships, this.props.domain["ownership-types"]);
        result.activity.turnovers = this.loadMultiCustom(result.activity.turnovers, v.activity.turnovers, this.props.domain["turnover-ranges"]);
        result.activity.turnoverYears = this.loadMultiCustom(result.activity.turnoverYears, v.activity.turnoverYears, this.props.domain["turnover-years"]);
        result.activity.employeeRanges = this.loadMultiCustom(result.activity.employeeRanges, v.activity.employeeRanges, this.props.domain["size-categories"]);
        result.activity.minEmployees = this.loadInt(v.activity.minEmployees, "");
        result.activity.maxEmployees = this.loadInt(v.activity.maxEmployees, "");
        result.activity.checked = v.activity.checked;

        //dotacie
        result.grants = this.loadExtended(sec.grants, v.grants);

        //stav subjektu
        result.status = sec.status || {};
        result.status.registrationFrom = this.loadDate(v.status.registrationFrom);
        result.status.registrationTo = this.loadDate(v.status.registrationTo);
        result.status.isVatPayer = this.loadTriStateDropdown(v.status.isVatPayer);
        result.status.isActive = this.loadTriStateDropdown(v.status.isActive);
        result.status.checked = v.status.checked;

        //zavazky
        result.sources = sec.sources || {};
        if (!isNullOrUndefined(v.sources)) {
            result.sources.positive = this.loadMultiCustom(result.sources.positive, v.sources.positive, this.props.domain['sources']);
            result.sources.negative = this.loadMultiCustom(result.sources.negative, v.sources.negative, this.props.domain['sources']);
            result.sources.checked = v.sources.checked;
        }

        //doplnujuce info
        result.additional = sec.additional || {};
        result.additional.positive = this.loadMultiCustom(result.additional.positive, v.additional.positive, this.props.domain['additional-info'], 2, 2, true);
        result.additional.negative = this.loadMultiCustom(result.additional.negative, v.additional.negative, this.props.domain['additional-info'], 2, 2, true);
        result.additional.checked = v.additional.checked;

        //varovne info
        result.warnings = sec.warnings || {};
        result.warnings.positive = this.loadMultiCustom(result.warnings.positive, v.warnings.positive, this.props.domain['warning-types'], 2, 2, true);
        result.warnings.negative = this.loadMultiCustom(result.warnings.negative, v.warnings.negative, this.props.domain['warning-types'], 2, 2, true);
        result.warnings.checked = v.warnings.checked;

        //financne udaje
        result.financial = sec.financial || {};
        result.financial.year = this.loadInt(v.financial.year, undefined);
        result.financial.checkLastOnly = v.financial.checkLastOnly || false;
        result.financial.values = {
            values: v.financial.values.values,
            condition: v.financial.values.condition,
            currency: v.financial.values.currency
        };
        if (!isNullOrUndefined(v.financial.valuesIfrs))
            result.financial.valuesIfrs = {
                values: v.financial.valuesIfrs.values,
                condition: v.financial.valuesIfrs.condition,
                currency: v.financial.valuesIfrs.currency
            };
        if (!isNullOrUndefined(v.financial.valuesIfrsOriginal))
            result.financial.valuesIfrsOriginal = {
                values: v.financial.valuesIfrsOriginal.values,
                condition: v.financial.valuesIfrsOriginal.condition,
                currency: v.financial.valuesIfrsOriginal.currency
            };
        result.financial.ratios = {
            values: v.financial.ratios.values,
            condition: v.financial.ratios.condition,
        };
        result.financial.checked = v.financial.checked;

        //financne udaje - organizacie
        // prepare organizations types
        if (unicornCountry() === 'sk' && !isNullOrUndefined(v.financial.organizationsValues)) {
            let typesValuesDict = [];
            let finValues = v.financial.organizationsValues.values.map(v => v.value);
            this.props.domain['fin-statement-values-organizations-types'].requestResult.forEach(type => {
                let finValuesForType = this.props.domain['fin-statement-values-organizations-values-' + type.value];
                if (isNullOrUndefined(finValuesForType.requestResult)) return;
                let count = finValuesForType.requestResult.filter(finValue => finValues.includes(finValue.value)).length;
                typesValuesDict.push({ type: type, count: count })
            });

            let selectedOrganizationsTypes = { all: [] };
            typesValuesDict.forEach((obj) => {
                if (obj.count > 0) selectedOrganizationsTypes.all.push(obj.type);
            })
            result.financial.organizationsTypes = { ...result.financial.organizationsTypes, all: [] }
            result.financial.organizationsTypes.all = selectedOrganizationsTypes.all;

            let all = {};
            typesValuesDict.filter(x => x.count > 0).forEach((type) => {
                let finValuesForType = this.props.domain['fin-statement-values-organizations-values-' + type.type.value].requestResult;
                let typeArray = [];
                v.financial.organizationsValues.values.forEach(val => {
                    let found = finValuesForType.filter(x => x.value === val.value);
                    if (found.length > 0) {
                        typeArray.push(val);
                    }
                });
                all[type.type.value] = { value: typeArray }
            })

            result.financial.organizationsValues.values = all;
        }

        //registrovane vozidla
        result.vehicles = { ...sec.vehicles, ...v.vehicles };
        result.vehicles.hasItems = this.loadTriStateDropdown((v.vehicles || sec.vehicles).hasItems);

        //zakladny kapital
        result.registeredCapital = { ...sec.registeredCapital, ...v.registeredCapital };
        result.registeredCapital.countFrom = v.registeredCapital.countFrom;
        result.registeredCapital.countTo = v.registeredCapital.countTo;
        result.registeredCapital.checked = v.registeredCapital.checked;
        // Make sure that values are always valid no matter what is loaded from DB
        //return mergeInto(dv, result);
        return result;
    }

    loadMultiCustom(target, source, domain, initialLevelLength = 2, valueLevelLength = 2, addParents = false) {
        return { ...target, ...source, ...loadMulti(source, domain, initialLevelLength, valueLevelLength, addParents) };
    }

    loadMultiCity(target, source, domain) {
        return { ...target, ...source, ...loadMultiCities(source, domain) };
    }

    loadExtended(sec, obj) {
        const result = sec || {};
        result.hasItems = this.loadTriStateDropdown(obj.hasItems);
        result.direction = this.loadInt(obj.direction);
        result.from = this.loadDate(obj.from);
        result.to = this.loadDate(obj.to);
        result.countFrom = this.loadInt(obj.countFrom);
        result.countTo = this.loadInt(obj.countTo);
        result.sumFrom = this.loadInt(obj.sumFrom);
        result.sumTo = this.loadInt(obj.sumTo);
        result.checked = obj.checked;
        result.currency = obj.currency;
        return result;
    }

    loadTriStateDropdown(obj) {
        return obj === true ? "1" : obj === false ? "0" : '';
    }

    loadDate(obj) {
        return isNullOrUndefined(obj) ? "" : moment(obj).format("DD.MM.YYYY");
    }

    loadInt(obj, defaultVal = undefined) {
        return isNullOrUndefined(obj) ? defaultVal : obj;
    }

    submitSearch(values) {
        this.setState({ isSubmitting: true }, () => {
            let id = this.getRequestId();
            if (id !== null)
                apiPost(`${getHostApi()}/api/marketing-list/request/${id}/update-search`, null, this.transformForPost(values),
                    (result) => this.submitDone(result.data), (result) => this.submitDone(result.data));
            else
                apiPost(`${getHostApi()}/api/marketing-list/search`, null, this.transformForPost(values),
                    (result) => this.submitDone(result.data), (result) => this.submitDone(result.data));
        });
    }

    getRequestId() {
        const qs = parseQuery(this.props.location.search);
        return (qs || {}).requestId || null;
    }

    getConfigId() {
        const qs = parseQuery(this.props.location.search);
        return (qs || {}).configId || null;
    }

    getExpandType() {
        const qs = parseQuery(this.props.location.search);
        return (qs || {}).expand || null;
    }

    hasDefaultFileContent() {
        return this.props.ml.sections.xlsFileContent.fileName === "";
    }

    hasDefaultValues(values) {
        return isEqual(values, this.props.ml.sections)
    }

    isSectionChecked = (sectionName) => {
        let section = Object.entries(this.props.ml.sections).find(s => s[0] === sectionName);
        return section[1].checked;
    }

    hasSectionPermission = (sectionName) => {
        let section = Object.entries(this.props.ml.sections).find(s => s[0] === sectionName);
        let role = section[1].role;
        if (role === null) return true;
        return hasPermission(null, role);
    }

    hasCheckedSection = () => {
        return Object.keys(this.props.ml.sections).map(x => this.props.ml.sections[x]).filter(s => s.hasOwnProperty("checked")).some(s => s.checked);
    }

    getBulkTemplateUrl(languageCode) {
        const langCode = isValidLanguage(languageCode) ? languageCode : "sk-SK";
        return `${getHostApi()}/api/marketing-list/download/${langCode}`;
    }

    getBulkTempFileUrl(file) {
        return !isGuid(file) ? "#" : `${getHostUrl()}/files/bulk/error/${file}`;
    }

    exception = (ex) => {
        if (isNullOrUndefined(ex)) return null;
        return <div className='pl-5'>
            <pre>{ex.Message}</pre>
            <pre>{ex.StackTrace}</pre>
            {!isNullOrUndefined(ex.InnerException) && this.exception(ex.InnerException)}
        </div>
    }

    submitDone(result) {
        this.setState({ result: result, isSubmitting: false });
        if (result.isSuccess) {
            if (document.querySelector("#fake-submit-params").getAttribute("data-redirect") !== "save") {
                const configId = this.getConfigId();
                if (configId === null)
                    this.props.redirectTo(`/unicorn/${unicornCountry()}/configuration?requestId=${result.requestId}`);
                else
                    this.props.redirectTo(`/unicorn/${unicornCountry()}/configuration?requestId=${result.requestId}&configId=${configId}`);
            } else {
                this.props.redirectTo(`/unicorn/${unicornCountry()}/templates`);
            }
        }
    }

    transformForPost(values) {

        let a = JSON.stringify(values);
        let b = JSON.parse(a);

        let c = JSON.parse(JSON.stringify(values));

        c = this.markSections(c);

        //address
        filterMulti(c.addr.regions, this.props.domain["regions"]);
        filterMulti(c.addr.districts, this.props.domain["districts"]);
        filterMulti(c.addr.cities, this.props.domain["cities"]);

        //premises
        c.premises.hasItems = this.filterTriStateDropdown(c.premises.hasItems);
        filterMulti(c.premises.regions, this.props.domain["regions"]);
        filterMulti(c.premises.districts, this.props.domain["districts"]);
        filterMulti(c.premises.cities, this.props.domain["cities"]);

        //procurements, grants and contracts
        this.sanitizeExtended(c.procurements);
        this.sanitizeExtended(c.grants);
        this.sanitizeExtended(c.contracts);

        //status
        c.status.registrationFrom = this.filterDate(c.status.registrationFrom);
        c.status.registrationTo = this.filterDate(c.status.registrationTo);
        c.status.isVatPayer = this.filterTriStateDropdown(c.status.isVatPayer);
        c.status.isActive = this.filterTriStateDropdown(c.status.isActive);

        //activity
        filterMulti(c.activity.nace, this.props.domain["nace"]);
        filterMulti(c.activity.institutionalSectors, this.props.domain["institutional-sectors"]);
        filterMulti(c.activity.ownerships, this.props.domain["ownership-types"]);
        filterMulti(c.activity.turnovers, this.props.domain["turnover-ranges"]);
        filterMulti(c.activity.turnoverYears, this.props.domain["turnover-years"]);
        filterMulti(c.activity.employeeRanges, this.props.domain["size-categories"]);
        c.activity.minEmployees = this.toInt(c.activity.minEmployees);
        c.activity.maxEmployees = this.toInt(c.activity.maxEmployees);

        //foreign trade
        filterMulti(c.foreignTrade.import, this.props.domain['countries-tree']);
        filterMulti(c.foreignTrade.export, this.props.domain['countries-tree']);

        //warnings, additional info and liabilities
        this.filterWarnings(c.additional, this.props.domain['additional-info']);
        this.filterWarnings(c.warnings, this.props.domain['warning-types']);
        this.filterWarnings(c.sources, this.props.domain['sources']);

        //financial
        delete c.financial.loaded;
        c.financial.values.values = c.financial.values.values.filter(x => x.value !== "").map(
            x => { return { from: this.toFloat(x.from), to: this.toFloat(x.to), value: x.value } });
        c.financial.valuesIfrs.values = c.financial.valuesIfrs.values.filter(x => x.value !== "").map(
            x => { return { from: this.toFloat(x.from), to: this.toFloat(x.to), value: x.value } });
        c.financial.valuesIfrsOriginal.values = c.financial.valuesIfrsOriginal.values.filter(x => x.value !== "").map(
            x => { return { from: this.toFloat(x.from), to: this.toFloat(x.to), value: x.value } });
        c.financial.ratios.values = c.financial.ratios.values.filter(x => x.value !== "").map(
            x => { return { from: this.toFloat(x.from), to: this.toFloat(x.to), value: x.value } });
        c.financial.year = this.toInt(c.financial.year);

        //financial organizations
        let aggregateOrgValues = [];
        Object.keys(c.financial.organizationsValues.values).map((k, i) => {
            c.financial.organizationsValues.values[k].value.filter(x => x.value !== "").forEach(
                x => { aggregateOrgValues.push({ from: this.toFloat(x.from), to: this.toFloat(x.to), value: x.value }) });
        });

        c.financial.organizationsValues = {
            condition: c.financial.organizationsTypes.condition,
            values: aggregateOrgValues
        }

        //vehicles
        c.vehicles.hasItems = this.filterTriStateDropdown(c.vehicles.hasItems);

        //legal form
        filterMulti(c.legalForm, this.props.domain['legal-form-types']);

        //xls file is not part of the form, assign here
        c.xlsFileContent = this.props.ml.sections.xlsFileContent;
        c.xlsFileChanged = this.state.fileChanged;

        c.portfolioId = this.state.portfolioId;
        c.portfolioSearchType = this.state.portfolioSearchType;
        c.excelSearchType = this.state.excelSearchType;

        c.country = unicornCountry();

        return c;
    }

    //sections are in state, we need to pass to server as well
    markSections(c) {
        const sections = this.props.ml.sections;
        this.markIfChecked(c, sections, "activity");
        this.markIfChecked(c, sections, "additional");
        this.markIfChecked(c, sections, "addr");
        this.markIfChecked(c, sections, "contracts");
        this.markIfChecked(c, sections, "financial");
        this.markIfChecked(c, sections, "foreignTrade");
        this.markIfChecked(c, sections, "grants");
        this.markIfChecked(c, sections, "legalForm");
        this.markIfChecked(c, sections, "procurements");
        this.markIfChecked(c, sections, "rating");
        this.markIfChecked(c, sections, "relationship");
        this.markIfChecked(c, sections, "sources");
        if (!c.status.checked) {
            c.status = { ...this.props.getDefaultSectionData('status'), checked: true };
        }
        this.markIfChecked(c, sections, "warnings");

        return c;
    }

    markIfChecked(c, sections, section) {
        if (!isNullOrUndefined(c[section])) {
            c[section].checked = !isNullOrUndefined(sections[section]) && sections[section].checked;
        }
    }

    filterWarnings(obj, domain) {
        filterMulti(obj.positive, domain, false, true);
        filterMulti(obj.negative, domain, false, true);
    }

    toInt(field) {
        return parseInt(field, 10) || null
    }

    toFloat(field) {
        return parseFloat(field) || null
    }

    sanitizeExtended = (obj) => {
        obj.hasItems = this.filterTriStateDropdown(obj.hasItems);
        obj.direction = this.toInt(obj.direction)
        obj.from = this.filterDate(obj.from);
        obj.to = this.filterDate(obj.to);
        obj.countFrom = this.toInt(obj.countFrom);
        obj.countTo = this.toInt(obj.countTo)
        obj.sumFrom = this.toInt(obj.sumFrom)
        obj.sumTo = this.toInt(obj.sumTo)
    }

    filterTriStateDropdown(obj) {
        return obj === 1 || obj === "1" ? true : obj === 0 || obj === "0" ? false : null;
    }

    filterDate(obj) {
        return isNullOrUndefined(obj) || obj === "" ? null : moment(obj, "DD.MM.YYYY").toISOString();
    }

    isEditing() {
        const qs = parseQuery(this.props.location.search) || {};
        if (qs.requestId !== undefined) {
            this.setState({ isEditing: true });
        }
    }

    checkMlAccount = () => {
        apiGet(`${getHostApi()}/api/account/has-account`, { accountTypeId: 8 },
            (r) => this.setState({ hasMlAccount: r.data }),
            (r) => writeErr(r),
            () => this.setState({ loading: false }));
    }

    //LegalForm fix
    loadMultiLegalForm(obj, domain, initialLevelLength, valueLevelLength) {
        if (isNullOrUndefined(obj) || isNullOrUndefined(domain.requestResult) || domain.requestResult.length === 0)
            return undefined;

        const result = {};
        if (obj.allSelected) {
            obj.all = [];
            domain.requestResult.forEach(r => findChildren(r, obj.all, false));
        }
        var longest = obj.all.length > 0 ? Math.max(...obj.all.map(v => v.length)) : 0;
        var parents = findParents(obj.all, longest);

        const all = obj.all.slice(0).map(i => this.findInTreeLegalForm(i, domain.requestResult));
        const parent = parents.map(i => this.findInTreeLegalForm(i, domain.requestResult));
        result.all = all.filter(f => !isNullOrUndefined(f) && !isNullOrUndefined(f.value));
        result.parent = parent.filter(f => !isNullOrUndefined(f) && !isNullOrUndefined(f.value));
        result.allSelected = obj.allSelected;
        return result;
    }

    findInTreeLegalForm(value, tree) {
        if (isNullOrUndefined(value) || isNullOrUndefined(tree))
            return null;

        //parent
        let node = tree.find(f => f.value === value);
        if (!isNullOrUndefined(node))
            return node;

        //children
        node = tree.find(f => f.children && f.children.find(f => f.value === value));

        if (!isNullOrUndefined(node))
            node = { ...node.children.find(f => f.value === value) }

        if (!isNullOrUndefined(node) && node.children !== undefined)
            node.children = undefined;

        return node;
    }
}
function dateInRange(value, section, format = "DD.MM.YYYY") {
    let result = isNullOrUndefined(value) || !section.checked || value === "";
    if (!result) {
        let formatted = isNullOrUndefined(format) ? moment(value) : moment(value, format);
        let now = moment();
        let result = formatted.isAfter(moment("31.12.1899", "DD.MM.YYYY")) && (formatted.isBefore(now) || formatted.isSame(now));
        return result;
    }
    return result;
}

function emptyStringToNull(value, originalValue) {
    if (typeof originalValue === 'string' && originalValue === '') {
        return null;
    }
    return value;
}

function maxCitiesLimitReached(selectedCities) {
    return selectedCities.length > 20;
}

export default connect(
    state => { return { user: state.userContext, ml: state.marketingList, domain: state.domain, ...state.layout } },
    dispatch => bindActionCreators(Object.assign({}, popupActions, marketingListActions, domainActions, layoutActions), dispatch))
    (withLocalize(withRouter(Parameters)));